export const removeUndefinedAttributes = (obj) => {
	return JSON.parse(JSON.stringify(obj));
};
